export default __webpack_public_path__ + "static/media/bhd.81b8c976.png";